/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { CancelConfirmRequestReasonCode } from './cancelConfirmRequestReasonCode';

export interface CancelConfirmRequest {
  reason_code?: CancelConfirmRequestReasonCode;
  reason_text?: string | null;
}
